import { setClassName } from '@change-corgi/core/error';

import { PageDataError } from '#src/shared/error';

import type { TopicRecentPetitionsQuery } from '../api.graphql';

export type TopicRecentPetitionsItem = NonNullable<
	TopicRecentPetitionsQuery['topicPage']
>['recentPetitionsConnection']['edges'][0];

/** @knip-ignore */
export type TopicPageDataErrorCode = 'topic_page_data_not_found';
/** @knip-ignore */
export class TopicPageDataError extends PageDataError<TopicPageDataErrorCode> {}
setClassName(TopicPageDataError, 'TopicPageDataError');
